import { useIsMobile } from 'hooks/useIsMobile'
import { LoginLayoutDesktop } from './LoginLayoutDesktop'
import { LoginLayoutMobile } from './LoginLayoutMobile'

export const LoginLayout = () => {
    const isMobile = useIsMobile()
    return isMobile ? <LoginLayoutMobile /> : <LoginLayoutDesktop />
}
